export const needsPersonalAccount = (user) => (typeof user?.account !== 'object');

export const needsLogin = (hasAccess, user) => (!user && !hasAccess);

export const needsVerification = (hasAccess, user) => (
  user && !user.verified && !hasAccess
);

export const needsSubscription = (hasAccess) => !hasAccess;
